import { Separator } from "@fluentui/react";
import React, { ReactNode } from "react";

import { Text } from "../items/Text";
import { ElevatedStack } from "../layouts/stack/ElevatedStack";

interface PublicElevatedSectionProps {
    children: ReactNode;
    headerText: string;
    width?: string | number;
    height?: number | string;
}

export const PublicElevatedSection: React.FC<PublicElevatedSectionProps> = ({
    headerText,
    width,
    height,
    children
}: PublicElevatedSectionProps) => {
    return (
        <ElevatedStack styles={{ root: { width: width ?? "25%", height: height ?? 500 } }}>
            <Text variant="xLarge" styles={{ root: { textAlign: "center" } }}>
                {headerText}
            </Text>
            <Separator />
            {children}
        </ElevatedStack>
    );
};
